import { Component } from '@angular/core';

import { Filters } from 'src/app/models/filters.model';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { Router, ActivatedRoute } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { concatMap, tap, shareReplay, catchError, finalize } from 'rxjs/operators';
import { SearcherService } from 'src/app/services/searcher.service';
import { Environment } from 'src/environments/environment';

@Component({
  selector: 'page-full-screen-directory',
  templateUrl: 'full-screen-directory.html',
  styleUrls: ['full-screen-directory.scss'],
  standalone: false
})
export class FullScreenDirectoryPage {
  public endpoint$ = new BehaviorSubject(`${Environment.API_BASE_URL_V2}/api/empatica/v1/users`);
  public itemType: string = 'contacts';
  public filters$: BehaviorSubject<Filters> = new BehaviorSubject({
    searchKey: '',
    start: 0,
    length: 20
  });
  public buttonSelected: string = 'agenda';
  private $event;

  private pageId: number;
  public page$: Observable<any>;
  /** Keeps item-searcher mounted on back navigation until page$ emits again */
  public latestPage: any = null;
  public forbidden: boolean = false;
  public listLoading = true;
  public readonly listSkeletonPlaceholders = [1, 2, 3];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private analyticsService: AnalyticsService,
    private searcherService: SearcherService
  ) {}

  ionViewDidEnter() {
    this.getItems();
  }

  public goToDetail($event) {
    const agenda = Boolean($event.item.username) ? '/agenda' : '';
    this.registerEventInAnalytics($event.item);
    this.router.navigate([`contacts/detail/${$event.item.id}${agenda}`]);
  }

  registerPageInAnalytics() {
    const paramsToAnalytics = { navigation: 1 };
    const name = 'Directory section';
    this.analyticsService.registerEvent(paramsToAnalytics, name);
  }

  registerEventInAnalytics(contact) {
    const paramsToAnalytics = { actions: 6 };
    const name = contact.name ? contact.name : 'Nombre de contacto';
    const id = contact.id;
    this.analyticsService.registerEvent(paramsToAnalytics, name, id);
  }

  private bindPage$() {
    this.page$ = this.filters$.pipe(
      concatMap((filters) =>
        this.searcherService.allItems(this.endpoint$.value, filters, this.itemType).pipe(finalize(() => (this.listLoading = false)))
      ),
      tap(() => this.$event && this.$event.target.complete && this.$event.target.complete()),
      tap((response) => {
        this.latestPage = response;
      }),
      tap(() => (this.forbidden = false)),
      catchError((err: any) => {
        if (err.status === 403) {
          this.forbidden = true;
        }

        throw err;
      }),
      shareReplay()
    );
  }

  public changeViewStatus(selected) {
    const segment = selected.detail.value;

    if (this.buttonSelected === segment) return;

    this.listLoading = true;
    this.latestPage = null;

    const endpoint =
      segment === 'agenda'
        ? `${Environment.API_BASE_URL_V2}/api/empatica/v1/users`
        : `${Environment.API_BASE_URL_V2}/api/empatica/v1/components/contacts`;

    this.endpoint$.next(endpoint);
    this.buttonSelected = segment;
    this.filters$.next({ ...this.filters$.value, start: 0, searchKey: '' });
    this.bindPage$();
  }

  getItems() {
    const nextPageId = +this.route.snapshot.paramMap.get('id');
    if (this.pageId !== undefined && nextPageId !== this.pageId) {
      this.latestPage = null;
    }
    this.pageId = nextPageId;

    this.listLoading = true;
    this.bindPage$();

    this.registerPageInAnalytics();
  }

  public getAllItems({ filters, event = null }) {
    if (event) this.$event = event;
    this.filters$.next(filters);
  }
}
